import { render, staticRenderFns } from "./JoinToComponent.vue?vue&type=template&id=165be25f&scoped=true&"
import script from "./JoinToComponent.vue?vue&type=script&lang=js&"
export * from "./JoinToComponent.vue?vue&type=script&lang=js&"
import style0 from "./JoinToComponent.vue?vue&type=style&index=0&id=165be25f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165be25f",
  null
  
)

export default component.exports